var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsdRightHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.903 43.249C163.903 43.249 170.482 44.3052 170.482 50.8841C170.482 57.463 163.903 57.9325 163.903 57.9325",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-593.643 70.8628V274.381H-459.573C-459.573 274.381 -456.28 215.861 -392.127 215.861C-392.127 215.861 -335.962 214.57 -327.263 274.381V299.529H22.3087H34.645",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3157 299.522V302.698L34.652 306.46H122.545V268.506C122.545 268.506 121.427 217.628 176.247 193.301C231.066 168.973 302.799 213.044 302.799 213.044L308.266 222.032V244.945L304.207 244.979L263.498 245.297C263.498 245.297 240.586 201.937 188.41 222.205C136.242 242.473 142.758 292.709 142.758 292.709C142.758 292.709 139.176 306.453 122.545 306.453",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.363 248.465H308.963L325 253.926V280.014H284.464C284.464 280.021 273.094 261.685 273.363 248.465Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.259 222.032C308.259 222.032 305.526 218.774 291.339 217.8V236.481C291.339 236.481 297.069 241.327 308.259 241.941",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-331.019 247.409C-331.019 247.409 -327.319 252.959 -325.731 260.277H28.8944V247.409H-331.019Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8422 253.843H-325.731",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-593.643 212.333H28.8944V206.521H-593.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-593.643 179.025H28.8944V165.805H-593.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8423 172.411H-589.059",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-594.085 145.709H28.8946V155.76H-593.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6519 70.8628V306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.974 306.454V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3501 306.453V76.9722H106.447V306.453",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.103 85.0767H49.6943V293.765H100.103V85.0767Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4309 70.8628H-67.6973V145.716H20.4309V70.8628Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7375 73.7412H-63.9902V106.346H16.7375V73.7412Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7375 110.93H-63.9902V142.83H16.7375V110.93Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-594.085 66.748H167.196",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.559 42.0757V61.6398H159.589V42.0757",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.589 61.6398L160.383 64.6358H163.91V40.4257H159.796V42.0687H157.566C153.162 32.7285 144.878 30.4366 144.878 30.4366C119.232 20.3922 32.2495 19.3291 32.2495 19.3291H-581.659C-597.64 36.0766 -593.643 70.8557 -593.643 70.8557H167.196V56.8695",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.244 73.7412L117.844 86.3743V153.116H161.087L150.041 79.0844H137.823V73.7412H131.244Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.728 150.734H121.137V87.0785L134.475 73.7412",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.041 79.0847L152.506 76.9723H156.503L158.574 80.1409H161.908V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.822 81.4385V119.98H146.955C148.661 119.98 150.041 118.599 150.041 116.894V84.904C150.041 82.9917 148.488 81.4385 146.576 81.4385H137.822Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.822 123.383V140.773H145.989C148.226 140.773 150.041 138.957 150.041 136.721V126.966C150.041 124.985 148.44 123.383 146.458 123.383H137.822Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.859 151.611H163.289V156.112",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.041 126.966H153.334V162.809H145.754V157.576V156.637H151.394V133.725H150.041V126.966Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.754 157.576L137.526 160.931",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.52 160.931L140.287 165.218L138.644 166.571",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.287 165.218V168.566H129.946V158.639H140.287V160.047",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.334 126.966V85.4907H150.041",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.041 88.252H151.684V110.929H150.041",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.041 112.987H151.684V126.966",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.334 156.112H176.247V193.301C176.247 193.301 188.673 195.682 188.41 222.205",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.407 138.309V172.853C283.407 172.853 289.931 170.029 294.156 155.581C294.163 155.581 294.867 141.746 283.407 138.309Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.247 156.112C176.247 156.112 259.183 165.715 288.792 177.264C288.792 177.264 302.537 179.556 302.799 213.044",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.407 139.365H281.468V170.388H283.407",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.375 171.486V177.699L282.054 181.019V190.042H284.643V182.373L288.654 178.362V168.124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.875 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.635 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.396 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.163 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.923 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.683 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.451 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.211 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.971 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.739 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.499 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.259 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.027 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.787 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.547 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.315 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.075 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.835 173.646V182.462",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 349.889C245.961 349.889 272.811 323.04 272.811 289.92C272.811 256.799 245.961 229.95 212.841 229.95C179.721 229.95 152.872 256.799 152.872 289.92C152.872 323.04 179.721 349.889 212.841 349.889Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 346.735C244.219 346.735 269.656 321.298 269.656 289.92C269.656 258.542 244.219 233.105 212.841 233.105C181.463 233.105 156.027 258.542 156.027 289.92C156.027 321.298 181.463 346.735 212.841 346.735Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 323.76C231.531 323.76 246.681 308.609 246.681 289.92C246.681 271.23 231.531 256.08 212.841 256.08C194.152 256.08 179.001 271.23 179.001 289.92C179.001 308.609 194.152 323.76 212.841 323.76Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 322.241C230.692 322.241 245.163 307.77 245.163 289.92C245.163 272.069 230.692 257.598 212.841 257.598C194.991 257.598 180.52 272.069 180.52 289.92C180.52 307.77 194.991 322.241 212.841 322.241Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 300.938C218.926 300.938 223.859 296.005 223.859 289.92C223.859 283.835 218.926 278.902 212.841 278.902C206.756 278.902 201.823 283.835 201.823 289.92C201.823 296.005 206.756 300.938 212.841 300.938Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 303.029C220.082 303.029 225.951 297.16 225.951 289.92C225.951 282.68 220.082 276.811 212.841 276.811C205.601 276.811 199.732 282.68 199.732 289.92C199.732 297.16 205.601 303.029 212.841 303.029Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.207 248.465V244.972",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.034 277.563L273.356 292.177",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.758 292.709H152.865",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.586 200.586C130.367 199.805 131.633 199.805 132.414 200.586L145.142 213.314C145.923 214.095 145.923 215.361 145.142 216.142C144.361 216.923 143.095 216.923 142.314 216.142L131 204.828L119.686 216.142C118.905 216.923 117.639 216.923 116.858 216.142C116.077 215.361 116.077 214.095 116.858 213.314L129.586 200.586ZM132.414 348.414C131.633 349.195 130.367 349.195 129.586 348.414L116.858 335.686C116.077 334.905 116.077 333.639 116.858 332.858C117.639 332.077 118.905 332.077 119.686 332.858L131 344.172L142.314 332.858C143.095 332.077 144.361 332.077 145.142 332.858C145.923 333.639 145.923 334.905 145.142 335.686L132.414 348.414ZM133 202L133 347L129 347L129 202L133 202Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 347,
    y2: -0.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 350 350)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 183C144 181.895 143.105 181 142 181H120C118.895 181 118 181.895 118 183V197C118 198.105 118.895 199 120 199H142C143.105 199 144 198.105 144 197V183ZM131.473 197.677H130.524C130.288 197.677 130.097 197.485 130.097 197.25V193.752C130.097 193.517 130.288 193.325 130.524 193.325H131.473C131.709 193.325 131.901 193.517 131.901 193.752V197.25C131.901 197.485 131.709 197.677 131.473 197.677ZM130.524 186.681H131.473C131.709 186.681 131.901 186.489 131.901 186.249V182.752C131.901 182.516 131.709 182.325 131.473 182.325H130.524C130.288 182.325 130.097 182.516 130.097 182.752V186.254C130.097 186.489 130.288 186.681 130.524 186.681ZM138.262 190.903H134.756C134.52 190.903 134.328 190.712 134.328 190.476V189.529C134.328 189.294 134.52 189.103 134.756 189.103H138.262C138.498 189.103 138.69 189.294 138.69 189.529V190.476C138.69 190.712 138.498 190.903 138.262 190.903ZM127.668 190.472V189.525C127.668 189.289 127.477 189.098 127.241 189.098H123.734C123.498 189.098 123.307 189.289 123.307 189.525V190.472C123.307 190.707 123.498 190.898 123.734 190.898H127.241C127.477 190.898 127.668 190.707 127.668 190.472ZM136.775 195.094L136.102 195.765C135.933 195.934 135.661 195.934 135.496 195.765L133.015 193.29C132.845 193.121 132.845 192.85 133.015 192.685L133.687 192.014C133.857 191.845 134.128 191.845 134.293 192.014L136.775 194.49C136.94 194.654 136.94 194.925 136.775 195.094ZM127.7 187.988C127.864 188.157 128.136 188.157 128.306 187.988L128.978 187.317C129.148 187.152 129.148 186.881 128.978 186.712L126.497 184.237C126.332 184.068 126.06 184.068 125.891 184.237L125.218 184.908C125.049 185.072 125.049 185.343 125.218 185.512L127.7 187.988Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white",
    transform: "matrix(-1 0 0 1 350 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsdRightHeight);
export default __webpack_public_path__ + "static/media/bsdRightHeight.a95b062b795656eda9218c70da95e7ea.svg";
export { ForwardRef as ReactComponent };